"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../../../index");

var AbstractParserWithWordBoundary_1 = require("../../../common/parsers/AbstractParserWithWordBoundary");

var dayjs_1 = __importDefault(require("dayjs"));

var dayjs_2 = require("../../../utils/dayjs");

var PATTERN = /(?:this)?\s{0,3}(morning|afternoon|evening|night|midnight|noon)(?=\W|$)/i;

var ENCasualTimeParser = /*#__PURE__*/function (_AbstractParserWithWo) {
  _inherits(ENCasualTimeParser, _AbstractParserWithWo);

  var _super = _createSuper(ENCasualTimeParser);

  function ENCasualTimeParser() {
    _classCallCheck(this, ENCasualTimeParser);

    return _super.apply(this, arguments);
  }

  _createClass(ENCasualTimeParser, [{
    key: "innerPattern",
    value: function innerPattern() {
      return PATTERN;
    }
  }, {
    key: "innerExtract",
    value: function innerExtract(context, match) {
      var targetDate = dayjs_1.default(context.refDate);
      var component = context.createParsingComponents();

      switch (match[1].toLowerCase()) {
        case "afternoon":
          component.imply("meridiem", index_1.Meridiem.PM);
          component.imply("hour", 15);
          break;

        case "evening":
        case "night":
          component.imply("meridiem", index_1.Meridiem.PM);
          component.imply("hour", 20);
          break;

        case "midnight":
          dayjs_2.assignTheNextDay(component, targetDate);
          component.imply("hour", 0);
          component.imply("minute", 0);
          component.imply("second", 0);
          break;

        case "morning":
          component.imply("meridiem", index_1.Meridiem.AM);
          component.imply("hour", 6);
          break;

        case "noon":
          component.imply("meridiem", index_1.Meridiem.AM);
          component.imply("hour", 12);
          break;
      }

      return component;
    }
  }]);

  return ENCasualTimeParser;
}(AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking);

exports.default = ENCasualTimeParser;